import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { SharedModule } from '../shared/shared.module'
import { ButtonModule } from 'primeng/button'
import { MessagingAppComponent } from './messaging-app.component'
import { ProgressSpinnerModule } from 'primeng/progressspinner'
import { CalendarModule } from 'primeng/calendar'
import { FormsModule } from '@angular/forms'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'

@NgModule({
   declarations: [MessagingAppComponent],
   imports: [CommonModule, SharedModule, ButtonModule, ProgressSpinnerModule, FormsModule, CalendarModule, BrowserAnimationsModule],
})
export class MessagingAppModule {}
